/* istanbul ignore file */
import { fireTag } from '@vue-util/tagManager';
import isBcom from './isBcom';

export function isFreeGwp(badge) {
  return (badge?.header?.toLowerCase() === 'free gift with purchase');
}

export function displayHeader(badge, overridePriceSimplification) {
  if (isBcom) {
    return !overridePriceSimplification ? badge.description : '';
  }
  return this.isFreeGwp(badge) ? badge.header.toLowerCase() : badge.header;
}

export function getBadgeTextWithoutLastWord(header) {
  const splittedHeader = header?.split(' ');
  splittedHeader?.pop();
  return `${splittedHeader?.join(' ')} `;
}

export function getBadgeLastWord(header) {
  const headerArr = header?.split(' ');
  return headerArr[headerArr.length - 1];
}

export function getTooltipContent(badge) {
  return `
        <div class="tooltip-content">
          <div class="tooltip-content__header">${badge?.header || ''}</div>
          <div>${badge?.description || ''}</div>
        </div>
      `;
}

export function plpToolTipClick() {
  if (!isBcom) {
    fireTag('link', {
      event_name: 'plp tool tip click',
      link_name: 'plp tool tip click',
    });
  }
}

export function isRemoveTooltipOnFgwpBadgeEnabled(badge, removeTooltipOnFgwpBadgeEnabled) {
  // removes tooltip from FreeGwp badges
  if (isFreeGwp(badge)) {
    return removeTooltipOnFgwpBadgeEnabled;
  }

  // removes tooltip from Loyalty badges
  const loyaltyRegex = /(star money|star rewards points)/;
  return loyaltyRegex.test(badge?.header?.toLowerCase());
}
